import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { JoinCtaButton } from './JoinCtaButton'
import { useAuth } from '../hooks/useAuth'
import { useScrollUpReveal } from '../hooks/useScrollUpReveal'
import { useT } from '../i18n/t'
import * as profilesApi from '../lib/api/profiles'

const HIDE_ON_PATHS = new Set([
  '/formularz',
  '/login',
  '/promocja25',
  '/promocja-25',
  '/newsletter-login',
])

export function MobileJoinBar() {
  const { t } = useT()
  const { pathname } = useLocation()
  const { user } = useAuth()
  const scrollUpVisible = useScrollUpReveal()
  const [isMembershipPaid, setIsMembershipPaid] = useState<boolean | null>(null)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1023px)')
    const update = () => setIsMobile(mq.matches)
    update()
    mq.addEventListener('change', update)
    return () => mq.removeEventListener('change', update)
  }, [])

  useEffect(() => {
    if (!user?.id) {
      queueMicrotask(() => setIsMembershipPaid(null))
      return
    }
    let cancelled = false
    void (async () => {
      try {
        const p = await profilesApi.getMyProfile()
        if (cancelled) return
        setIsMembershipPaid(Boolean(p?.membership_paid_at))
      } catch {
        if (!cancelled) setIsMembershipPaid(null)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [user?.id])

  const showBar =
    isMobile && scrollUpVisible && isMembershipPaid !== true && !HIDE_ON_PATHS.has(pathname)

  return (
    <div
      aria-hidden={!showBar}
      className={[
        'fixed inset-x-0 bottom-0 z-[105] border-t border-ink/10 bg-paper/95 backdrop-blur-md transition-transform duration-300 ease-out lg:hidden',
        showBar ? 'translate-y-0' : 'pointer-events-none translate-y-full',
      ].join(' ')}
    >
      <div className="container-x pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3">
        <JoinCtaButton size="md" fullWidth>
          {t('nav.join')}
        </JoinCtaButton>
      </div>
    </div>
  )
}
